import * as apiGetRecurringNotifications from '../../api/recurringNotifications/getRecurringNotifications.js';
import * as apiCreateRecurringNotification from '../../api/recurringNotifications/createRecurringNotification.js';
import * as apiUpdateRecurringNotification from '../../api/recurringNotifications/updateRecurringNotification.js';
import * as apiDeleteRecurringNotification from '../../api/recurringNotifications/deleteRecurringNotification.js';
import * as apiTestTargetingCount from '../../api/recurringNotifications/testTargetingCount.js';

const state = {
  recurringNotifications: []
};

const mutations = {
  SET_RECURRING_NOTIFICATIONS(state, recurringNotifications) {
    state.recurringNotifications = recurringNotifications;
  }
};

const actions = {
  async getRecurringNotifications({ commit }) {
    try {
      const recurringNotifications = await apiGetRecurringNotifications.get();
      commit('SET_RECURRING_NOTIFICATIONS', recurringNotifications);
      return recurringNotifications;
    } catch (error) {
      console.error('Error fetching recurring notifications:', error);
      throw error;
    }
  },

  async createRecurringNotification({ dispatch }, recurringNotificationData) {
    try {
      await apiCreateRecurringNotification.create(recurringNotificationData);
      await dispatch('getRecurringNotifications'); // Refresh the list
    } catch (error) {
      console.error('Error creating recurring notification:', error);
      throw error;
    }
  },

  async updateRecurringNotification({ dispatch }, { id, data }) {
    try {
      await apiUpdateRecurringNotification.update(id, data);
      await dispatch('getRecurringNotifications'); // Refresh the list
    } catch (error) {
      console.error('Error updating recurring notification:', error);
      throw error;
    }
  },

  async deleteRecurringNotification({ dispatch }, id) {
    try {
      await apiDeleteRecurringNotification.del(id);
      await dispatch('getRecurringNotifications'); // Refresh the list
    } catch (error) {
      console.error('Error deleting recurring notification:', error);
      throw error;
    }
  },

  async testTargetingCount(_unused, targetingData) {
    try {
      const result = await apiTestTargetingCount.testTargetingCount(targetingData);
      return result;
    } catch (error) {
      console.error('Error testing targeting count:', error);
      throw error;
    }
  }
};

const getters = {
  recurringNotifications: (state) => state.recurringNotifications
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
